import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import { useLocation } from 'react-router-dom';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import axios from 'axios';
import { site_url, invoice_img } from "./../config.js";
import { IndianCurrencyFormatter, FormatDate } from './../Function';


export default function Index() {

    const queryParams = new URLSearchParams(useLocation().search);
    const id = queryParams.get('id');
    const [data, setdata] = useState([]);

    useEffect(() => {
        const paymentdetails = async () => {
            try {
                const response = await axios.get(site_url + '/vendor/paymentdetails/' + id);
                if (response.data.status == 'success') {
                    setdata(response.data);
                }
            } catch (error) {

            }
        }
        paymentdetails();
    }, [id])

    return (
        <div>
            {data != '' ?
                <div className="row mt-2"><br></br>

                    <div className="col-12">

                        <div className="stat-box mt-2">
                            <center>
                                <img
                                    style={{ marginTop: '6%', width: '70px' }}
                                    src={invoice_img}
                                    alt="img"
                                    className="image-block imaged "
                                />
                            </center>
                            <h1 style={{ fontWeight: '700' }} className='mt-2'><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax))} /> </h1>

                            <b>{FormatDate(data.billorder.created_at)}</b><br></br>
                            <br></br>
                            <b style={{ color: 'black' }}>Details</b>
                            <table className="table table-bordered">

                                <tbody>
                                    <tr>
                                        <th scope="col"><b>Bill ID</b></th>
                                        <th scope="col"><b>#{data.billorder.billno}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Customer Name</b></th>
                                        <th scope="col"><b>{data.customer.username}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Customer Phone</b></th>
                                        <th scope="col"><b>{data.customer.phone}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Amount</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount))} /></b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Tax</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.tax))} /></b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Pay status</b></th>
                                        <th scope="col"><b>  {(data.billorder.is_paid == '0' ?
                                            <span class="badge badge-success">Paid</span>
                                            :
                                            <span class="badge badge-danger">Un-Paid</span>
                                        )}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Type</b></th>
                                        <th scope="col"><b>
                                            {(data.billorder.paytype == 'cash' ?
                                                <span class="badge badge-success">Cash</span>
                                                :
                                                <span class="badge badge-danger">Online</span>
                                            )}
                                        </b></th>
                                    </tr>
                                </tbody>
                            </table>
                            <br></br>
                            <b style={{ color: 'black' }}>Payment Details</b>
                            <br></br>
                            <table className="table table-bordered">

                                <tbody>

                                    <tr>
                                        <th scope="col"><b>Total Bill Amount</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax))} /></b></th>
                                    </tr>

                                    <tr>
                                        <th scope="col"><b style={{ color: 'red' }}>Admin Commission</b></th>
                                        <th scope="col"><b>{data.billorder.admincommisition}%</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b style={{ color: 'red' }}>Commission Amount</b></th>
                                        <th scope="col"><b style={{ fontSize: '16px', color: 'black', fontWeight: '700' }}><IndianCurrencyFormatter amount={((((parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax)) / 100) * data.billorder.admincommisition))} /></b></th>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>

                :

                <div class="spinner-grow text-primary" role="status"></div>


            }
            <Footer />
            <Sidebar />

        </div>
    )
}
